export default __webpack_public_path__ + "static/media/tic tac toe.108c4de2.svg";